<template>
  <div>
    <Row v-show="!hasFile">
      <Input :placeholder="$t('audio.tip1')" size="large" readonly />
      <input :id="inputId" accept=".wav" class="input-box" type="file" @change="showFile($event)"></input>
    </Row>
    <Row v-show="hasFile" gutter="20">
      <i-col span="22">
        <span class="file-name">{{ uploadTip }}</span>
      </i-col>
      <i-col span="2">
        <Button type="error" ghost icon="md-trash" @click="handleDelFile"></Button>
      </i-col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "inputBox",
  components: {},
  props: {
    inputId: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    // 这里存放数据
    return {
      hasFile: false,
      uploadTip: "",
      binaryArray: [], // 文件的二进制数组
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // 上传文件
    showFile($event) {
      debugger;
      let _this = this;
      let el = $event.currentTarget;
      let file = el.files[0];
      // 检验格式
      let lastName = file.name.split(".").reverse()[0];
      let allowPicReg = ["wav"];
      if (!allowPicReg.includes(lastName)) {
        this.$Message.error(this.$t("audio.tip3"));
      } else {
        // 限制上传大小1m
        let fileSize = file.size;
        if (fileSize > 1024 * 1024) {
          this.$Message.error({
            background: true,
            content: this.$t("audio.tip2"),
          });
          return;
        }
        let name = file.name;
        this.uploadTip = name;
        this.hasFile = true;
        this.$forceUpdate();

        // 创建FileReader对象
        const reader = new FileReader();

        // 以二进制数组格式读取文件
        reader.readAsArrayBuffer(file);
        // 定义读取完成的回调函数
        reader.onload = function (e) {
          // 读取完成后，e.target.result包含二进制数据
          const binaryData = e.target.result;
          // 在这里可以对二进制数据进行处理
          console.log("binaryDatabinaryData:::" + typeof binaryData);
          console.log(binaryData);

          const binaryObj = {
            index: _this.index,
            binaryData: binaryData,
          };
          _this.$emit("getBinaryData", binaryObj);
        };
      }
    },
    // 删除文件
    handleDelFile() {
      let fileDom = document.getElementById(this.inputId);
      fileDom.form.reset();
      this.hasFile = false;
      const binaryObj = {
        index: this.index,
        binaryData: [],
      };
      this.$emit("getBinaryData", binaryObj); // 置空
    },
  },
};
</script>
<style scoped lang='scss'>
.input-box {
  width: 100%;
  margin-top: -40px;
  z-index: 9999;
  opacity: 0;
  cursor: pointer;
}

.file-name {
  word-wrap: break-word;
}
</style>